export const COL = 'COL'
export const PER = 'PER'
export const WRD = 'WRD'
